var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"vrm-open--vue","mode":"out-in"}},[(_vm.open)?_c('div',{staticClass:"vrm-togglable-panel vrm-open--vue"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }